import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { ExpenseWithCostsServices } from '../services/expenseWithCostsServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


export default class ExpenseWithCostsStore {    

    
  rootStore;
    expensesWithCosts = [];
    expenseWithCosts = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,

          expensesWithCosts: observable,
          expenseWithCosts: observable,

          getAll: action,          
          reset: action,
          save: action,
          remove: action,
          duplicate:action
      });
      makePersistable(this, { name: 'expenseWithCostsStore', properties: ['config'], storage: window.localStorage });

    }          

    duplicate = async (id) => {
        try {
            const data = await ExpenseWithCostsServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("expenseWithCosts") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    remove = async (id) => {
        try {
            const data = await ExpenseWithCostsServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("expenseWithCosts") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await ExpenseWithCostsServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("expenseWithCosts") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await ExpenseWithCostsServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("expenseWithCosts") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.expenseWithCosts = {});
    }
    
    
    setConfig = (prop, c) => { this.config[prop] = c; }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await ExpenseWithCostsServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.expensesWithCosts = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.expensesWithCosts = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await ExpenseWithCostsServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => { this.expensesWithCosts = data;})
        }
        catch (error) {
            runInAction(() => { this.expensesWithCosts = [];});
        }
    }    

    getById = async (id) => {
        try {
            const data = await ExpenseWithCostsServices.getById(id);
            runInAction(() => { this.expenseWithCosts = data;});
        } catch (error) {
            runInAction(() => { this.expenseWithCosts = {};})
        }
    };

    
}